import React from 'react';
import './MainNavBar.css'; // nếu muốn tách CSS riêng

export default function MainNavBar() {
  return (
    <nav className="navbar">
      <ul className="navbar-list">
        <li><a href="/"><i className="fas fa-home"></i> Trang chủ</a></li>
        <li><a href="https://visaothe.net" target="_blank" rel="noopener noreferrer"><i className="fas fa-share-alt"></i> Chia Sẻ Phần Mềm</a></li>
        <li><a href="https://upload.elecom-vn.com" target="_blank" rel="noopener noreferrer"><i className="fas fa-upload"></i> Upload Ảnh</a></li>
        <li><a href="https://2fa.visaothe.net" target="_blank" rel="noopener noreferrer"><i className="fas fa-lock"></i> 2FA</a></li>
        <li><a href="https://visaothe.net/gioithieu" target="_blank" rel="noopener noreferrer"><i className="fas fa-info-circle"></i> Giới Thiệu</a></li>
        <li><a href="https://visaothe.net/donate/" target="_blank" rel="noopener noreferrer"><i className="fas fa-donate"></i> Ủng Hộ</a></li>
      </ul>
    </nav>
  );
}
